import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  SaktiBkmKpiResponse,
  SaktiBkmListResponse,
  SaktiBkmDetailResponse,
  SaktiBkmSimulationResponse,
  SaktiFilters,
} from '../types';

const buildBkmParams = (filters: SaktiFilters & { page?: number; limit?: number }) => {
  const params: Record<string, string | number> = {
    date: filters.date,
  };

  if (filters.company_id) params.company_id = filters.company_id;
  if (filters.estate_id) params.estate_id = filters.estate_id;
  if (filters.division_id) params.division_id = filters.division_id;
  if (filters.page) params.page = filters.page;
  if (filters.limit) params.limit = filters.limit;

  return params;
};

export class SaktiBkmApiService {
  static async getKpi(filters: SaktiFilters): Promise<SaktiBkmKpiResponse> {
    const response = await api.get<SaktiBkmKpiResponse>(SAKTI_API_CONFIG.BKM_KPI_PATH, {
      params: buildBkmParams(filters),
    });
    return response.data;
  }

  static async getList(filters: SaktiFilters & { page?: number; limit?: number }): Promise<SaktiBkmListResponse> {
    const response = await api.get<SaktiBkmListResponse>(SAKTI_API_CONFIG.BKM_LIST_PATH, {
      params: buildBkmParams(filters),
    });
    return response.data;
  }

  static async getDetail(id: string): Promise<SaktiBkmDetailResponse> {
    const response = await api.get<SaktiBkmDetailResponse>(SAKTI_API_CONFIG.BKM_DETAIL_PATH(id));
    return response.data;
  }

  static async getSimulation(divisionId: number, date: string): Promise<SaktiBkmSimulationResponse> {
    const response = await api.get<SaktiBkmSimulationResponse>(SAKTI_API_CONFIG.BKM_SIMULATION_PATH, {
      params: { division_id: divisionId, date },
    });
    return response.data;
  }

  static async editBkm(id: string, payload: any): Promise<any> {
    const response = await api.patch(SAKTI_API_CONFIG.BKM_EDIT_PATH(id), payload);
    return response.data;
  }
}

export default SaktiBkmApiService;
